import EditPost from "./../MainType/EditPost";
import {defaultSnackbarOptions} from "../../../../Config";
import {withSnackbar} from "react-simple-snackbar";
import {matchPath} from "react-router";
import {react_intl} from "../../../../index";

class Edit extends EditPost {
    title = react_intl.formatMessage({id:"admin.content.pages.edit.text"})
    back_url = "/admin/pages"
    pathScheme = "/admin/pages/:id"
    back_text = react_intl.formatMessage({id:"admin.content.pages.edit.back_text"})
    action = "edit"
    thumbnail = false
    content_type = "page"

    getParams = (pathname) => {
        const matchProfile = matchPath(pathname, {
            path: this.pathScheme,
        });
        return (matchProfile && matchProfile.params) || {};
    }

    constructor(props) {
        super(props);
        let params = this.getParams(props.location.pathname, this.pathScheme)
        this.postId = params.id
    }

}

export default withSnackbar(Edit, defaultSnackbarOptions)